import { DATE_YMD_PREFIX_REGEX, DATE_YMD_STRICT_REGEX } from "./regexPatterns";

/**
 * Extracts the public YYYY-MM-DD portion of a date-like value without
 * introducing timezone conversion.
 *
 * @param {*} value Date-like value.
 * @returns {string} Date formatted as YYYY-MM-DD or an empty string.
 */
export function ExtractDateYmd(value) {
    if (!value) {
        return "";
    }

    const match = String(value).match(DATE_YMD_PREFIX_REGEX);
    return match ? match[1] : "";
}

/**
 * Checks whether a value already follows the YYYY-MM-DD contract.
 *
 * @param {*} value Date value.
 * @returns {boolean} True when the value has the exact public date shape.
 */
export function IsDateYmd(value) {
    return typeof value === "string" && DATE_YMD_STRICT_REGEX.test(value);
}
